module.exports = __webpack_public_path__ + "ba1e65a288da044c517c2e08ee17af0e.pdf";